import { TranslationLabels } from "translations/TranslationLabels";

export enum AgendaItemTypeEnum {
  Empty = 0,
  Decision = 1,
  Decision_eDecide = 2,
  Information = 3,
  Information_eDecide = 4,
  Other = 5,
  Break = 6,
  Category = 7,
  Discussion = 8,
}

export const getAgendaItemTypeLabel = (type: AgendaItemTypeEnum | unknown, i18n: TranslationLabels): string => {
  switch (type) {
    case AgendaItemTypeEnum.Empty:
      return "";
    case AgendaItemTypeEnum.Decision:
      return i18n.AgendaItemType_Decision;
    case AgendaItemTypeEnum.Decision_eDecide:
      return i18n.AgendaItemType_Decision_eDecide;
    case AgendaItemTypeEnum.Information:
      return i18n.AgendaItemType_Information;
    case AgendaItemTypeEnum.Information_eDecide:
      return i18n.AgendaItemType_Information_eDecide;
    case AgendaItemTypeEnum.Other:
      return i18n.AgendaItemType_Other;
    case AgendaItemTypeEnum.Break:
      return i18n.AgendaItemType_Break;
    case AgendaItemTypeEnum.Category:
      return i18n.AgendaItemType_Category;
    case AgendaItemTypeEnum.Discussion:
      return i18n.AgendaItemType_Discussion;
    default:
      return "";
  }
};
